<div class="modal-content importador-csv-modal">
  <!-- Modal Header -->
  <div class="modal-header bg-primary text-white">
    <h4 class="modal-title d-flex align-items-center" id="myModalLabel">
      <i class="mdi mdi-upload mr-2"></i>
      Importador no Catálogo <strong>{{catalogo?.nome}}</strong> via CSV
    </h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="this.feche()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <!-- Mensagens de Feedback -->
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="mensagemSucesso">
      <i class="mdi mdi-check-circle mr-2"></i>
      {{mensagemSucesso}}
      <button type="button" class="close" aria-label="Fechar" (click)="fecheMensagemSucesso()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- Etapa 1: Upload e Configuração -->
    <div  class="importacao-step"  [hidden]="!buscarProdutos || importando">
      <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
            novalidate #frm="ngForm" (ngSubmit)="onSubmit()">

        <!-- Card de Upload -->
        <div class="card mb-4">
          <div class="card-header bg-light">
            <h6 class="mb-0">
              <i class="mdi mdi-file-upload mr-2"></i>
              Etapa 1: Upload do Arquivo CSV
            </h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group">
                  <label for="arquivo" class="font-weight-bold">
                    <i class="mdi mdi-file-document-outline mr-1"></i>
                    Arquivo CSV:
                  </label>
                  <kendo-fileselect
                    id="arquivo"
                    name="arquivo"
                    (select)="selecionouArquivo($event)"
                    [(ngModel)]="files"
                    [multiple]="false"
                    [restrictions]="restricoes"
                    required>
                    <kendo-fileselect-messages
                      select="Selecione um arquivo CSV..."
                      clearSelectedFiles="Limpar">
                    </kendo-fileselect-messages>
                  </kendo-fileselect>
                  <small class="form-text text-muted">
                    Formatos aceitos: .csv (máximo 10MB)
                  </small>
                  <div class="invalid-feedback">
                    <p *ngIf="files.errors?.required">Arquivo é obrigatório</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="mdi mdi-format-list-numbered mr-1"></i>
                    Separador Decimal:
                  </label>
                  <kendo-dropdownlist
                    name="separadorDecimal"
                    [data]="opcoesSeparadorDecimal"
                    class="form-control" required
                    valueField="codigo"
                    textField="descricao"
                    placeholder="Selecione o separador"
                    [(ngModel)]="separadorDecimal">
                  </kendo-dropdownlist>
                  <small class="form-text text-muted">
                    Para o campo preço
                  </small>
                  <div class="invalid-feedback">
                    <p *ngIf="!separadorDecimal">Obrigatório</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card de Preview dos Dados -->
        <div class="card" *ngIf="conteudoArquivo && conteudoArquivo.length > 0">
          <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <i class="mdi mdi-eye mr-2"></i>
              Etapa 2: Configuração das Colunas
            </h6>
            <span class="badge badge-info">
              {{conteudoArquivo.length - (removeuPrimeiraLinha ? 1 : 0)}} produtos encontrados
            </span>
          </div>
          <div class="card-body">
            <div class="alert alert-info">
              <i class="mdi mdi-information mr-2"></i>
              <strong>Configure o mapeamento das colunas:</strong> Selecione qual coluna do CSV corresponde a cada campo do sistema.
            </div>

            <!-- Tabela de Preview -->
            <div class="preview-table-container">
              <div class="table-responsive-wrapper">
                <table class="table table-striped table-bordered table-hover">
                  <thead class="thead-light">
                    <tr>
                      <th *ngFor="let item of colunasImportar"
                          [ngClass]="{'d-none': item.removida  }"
                          class="column-header">
                        <div class="column-mapping-container">
                          <div class="column-mapping">
                            <kendo-dropdownlist
                              name="colunaImportar{{item.indice+1}}"
                              [data]="tipoImportar.colunas"
                              class="form-control form-control-sm"
                              textField="descricao"
                              placeholder="Mapear coluna..."
                              [(ngModel)]="item.coluna">
                            </kendo-dropdownlist>
                          </div>
                          <button class="btn btn-sm btn-outline-danger remove-column-btn"
                                  (click)="removaColuna(item)" type="button"
                                  title="Remover coluna" >
                            <i class="mdi mdi-close"></i>
                          </button>
                        </div>
                      </th>
                      <th width="80" class="actions-column">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let linha of this.primeirasLinhas(); let ilinha = index;">
                      <ng-container *ngIf="ilinha > 0 || !removeuPrimeiraLinha">
                        <tr [ngClass]="{'table-danger': linha.erro}">
                          <td *ngFor="let coluna of linha; let i = index;"
                              [ngClass]="{'d-none': colunasRemovidas.indexOf(i)>=0  }"
                              class="data-cell">
                            <div class="cell-content"
                                 [title]="coluna">
                              {{coluna && coluna.length > 30 ? coluna.substring(0, 30) + '...' : coluna || '-'}}
                            </div>
                          </td>
                          <td class="actions-cell">
                            <button class="btn btn-sm btn-outline-danger"
                                    (click)="removaLinha(linha, ilinha)"
                                    *ngIf="ilinha==0"  type="button"
                                    title="Remover cabeçalho">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Informações adicionais -->
            <div class="row mt-3">
              <div class="col-12">
                <div class="alert alert-warning">
                  <i class="mdi mdi-lightbulb mr-2"></i>
                  <strong>Dicas:</strong>
                  <ul class="mb-0 mt-2">
                    <li>Se a primeira linha contém cabeçalhos, clique no botão vermelho para removê-la</li>
                    <li>Para remover uma coluna inteira, clique no botão "X" no cabeçalho da coluna</li>
                    <li>Use o scroll horizontal para ver todas as colunas do arquivo</li>
                  </ul>
                </div>
              </div>
            </div>


            <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="mensagemErro">
              <i class="mdi mdi-alert-circle mr-2"></i>
              {{mensagemErro}}
              <button type="button" class="close" aria-label="Fechar" (click)="fecheMensagemErro()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Botões de Ação -->
            <div class="form-actions mt-4">
              <button type="submit"
                      *ngIf="!importou && !somentePrecos"
                      class="btn btn-success btn-lg"
                      [disabled]="importando">
                <i class="mdi mdi-upload mr-2"></i>
                Importar Produtos
              </button>

              <button type="submit"
                      *ngIf="!importou && somentePrecos"
                      class="btn btn-primary btn-lg"
                      [disabled]="carregando || !conteudoArquivo || !separadorDecimal">
                <i class="k-icon k-i-loading mr-2" *ngIf="carregando"></i>
                <i class="mdi mdi-table mr-2" *ngIf="!carregando"></i>
                Carregar Tabela de Preços
              </button>

              <button type="button"
                      class="btn btn-secondary btn-lg"
                      (click)="feche()">
                <i class="mdi mdi-close mr-2"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Tela de Carregamento -->
    <div *ngIf="importando" class="text-center py-5">
      <div class="loading-container">
        <i class="k-icon k-i-loading" style="font-size: 60px; color: #007bff;"></i>
        <h5 class="mt-3">Importando catálogo...</h5>
        <p class="text-muted">Por favor, aguarde enquanto processamos os dados.</p>
      </div>
    </div>

    <!-- Tela de Sincronização -->
    <div  [hidden]="buscarProdutos">
      <div class="alert alert-info alert-dismissible fade show" *ngIf="tudoSincronizado" role="alert">
        <i class="mdi mdi-check-all mr-2"></i>
        <h6 class="mb-0">Não há nenhum preço para atualizar</h6>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <app-painel-importacao-produtos
        #painelImportacao
        [hidden]="tudoSincronizado">
      </app-painel-importacao-produtos>
    </div>
  </div>

  <!-- Footer para Sincronização -->
  <div class="modal-footer bg-light" [hidden]="buscarProdutos">
    <button type="button"
            class="btn btn-danger btn-lg"
            (click)="painelImportacao.sincronizeTodos()"
            [disabled]="tudoSincronizado || painelImportacao.importacao.sincronizando">
      <i class="k-icon k-i-loading mr-2" *ngIf="painelImportacao.importacao.sincronizando"></i>
      <i class="mdi mdi-sync mr-2" *ngIf="!painelImportacao.importacao.sincronizando"></i>
      Sincronizar Todos
    </button>

    <button type="button"
            class="btn btn-secondary btn-lg"
            (click)="volteTela()">
      <i class="mdi mdi-arrow-left mr-2"></i>
      Voltar
    </button>
  </div>
</div>
